// Single source of truth for every page's <title>, description and canonical URL.
// Used by <PageMeta /> in the browser and by scripts/prerender.js at build time.
import { services, industries } from "../data/mock";
import { seoPages } from "../data/seo-pages";

export const SITE_URL = "https://flexitech.net.au";
const BRAND = "FlexiTech";

const clip = (text, max = 158) => {
  if (!text || text.length <= max) return text;
  const cut = text.slice(0, max - 1);
  return cut.slice(0, cut.lastIndexOf(" ")).replace(/[,;:\s]+$/, "") + "…";
};

const STATIC_PAGES = {
  "/": {
    title: "IT Support Sydney | Managed IT Services for Small Business | FlexiTech",
    description:
      "Sydney-based managed IT support, cybersecurity, Microsoft 365 and Azure cloud services for small and medium businesses across Australia. Book a free consultation.",
  },
  "/services": {
    title: `IT Services: Managed Support, Cybersecurity, Microsoft 365 & Azure | ${BRAND}`,
    description:
      "Managed IT support, Microsoft 365, email migration, servers, Active Directory, cybersecurity, backup, Azure cloud and networking for Australian businesses.",
  },
  "/industries": {
    title: `IT Support for Medical, Legal, Real Estate & Accounting Firms | ${BRAND}`,
    description:
      "Specialist IT support for medical centres, law firms, real estate agencies, accounting firms and small businesses in Sydney and across Australia.",
  },
  "/about": {
    title: `About ${BRAND} | Sydney-Based IT Support Team`,
    description:
      "FlexiTech is a Sydney-based IT support provider with 20+ years of IT experience, helping Australian small businesses with reliable, secure technology.",
  },
  "/why-flexitech": {
    title: `Why Choose ${BRAND} for Your Business IT Support`,
    description:
      "Local Australian IT experts, proactive support and plain-English advice. See how FlexiTech compares and why businesses choose us for managed IT.",
  },
  "/contact": {
    title: `Contact ${BRAND} | Book a Free IT Consultation`,
    description:
      "Call 02 9191 7464 or email info@flexitech.net.au to book a free consultation about IT support, cybersecurity or cloud services for your business.",
  },
};

const NOT_FOUND = {
  title: `Page Not Found | ${BRAND}`,
  description: "Sorry, this page could not be found.",
  noindex: true,
};

const normalise = (pathname) => {
  const p = (pathname || "/").split(/[?#]/)[0].replace(/\/+$/, "");
  return p === "" ? "/" : p;
};

export function getRouteMeta(pathname) {
  const path = normalise(pathname);
  let meta = STATIC_PAGES[path];

  let m;
  if (!meta && (m = path.match(/^\/services\/([^/]+)$/))) {
    const s = services.find((x) => x.id === m[1]);
    if (s) meta = { title: `${s.seoTitle || s.title} | ${BRAND}`, description: clip(s.shortDesc) };
  }
  if (!meta && (m = path.match(/^\/industries\/([^/]+)$/))) {
    const i = industries.find((x) => x.id === m[1]);
    if (i) meta = { title: `${i.seoTitle || i.title} | ${BRAND}`, description: clip(i.shortDesc) };
  }
  if (!meta && (m = path.match(/^\/seo\/([^/]+)$/))) {
    const p = seoPages.find((x) => x.id === m[1]);
    if (p) meta = { title: p.metaTitle, description: clip(p.metaDescription) };
  }

  if (!meta) return { ...NOT_FOUND, path, canonical: null };
  return { ...meta, path, canonical: SITE_URL + (path === "/" ? "/" : path), noindex: false };
}

export function getAllRoutes() {
  return [
    ...Object.keys(STATIC_PAGES),
    ...services.map((s) => `/services/${s.id}`),
    ...industries.map((i) => `/industries/${i.id}`),
    ...seoPages.map((p) => `/seo/${p.id}`),
  ];
}
